export class TdoTimeModel {
  date: Date;
  dateStr: string = '';
  name: string='T';
}
